import { LegalFooter } from '../components/LegalFooter.js';
import { Link } from '../components/Link.js';
import { Logo } from '../design/index.js';

/**
 * The site's foot.
 *
 * The legal obligations live in `LegalFooter` and are reused verbatim here —
 * mentions légales, information of the data subject, withdrawing consent — so
 * there is one implementation of them and one place they can be got wrong.
 * This adds the navigation and the wordmark around it.
 */
export function SiteFooter({ loginUrl }: { readonly loginUrl: string }): React.JSX.Element {
  return (
    <footer className="on-dark border-t border-line-dark bg-violet-deep py-12">
      <div className="shell">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <Logo tone="dark" />
            <p className="mt-3 max-w-xs text-ui-sm text-ink-light-muted">
              La réception téléphonique des professionnels de la beauté.
            </p>
          </div>

          <nav aria-label="Pied de page">
            <ul className="grid gap-2 text-ui-sm sm:grid-cols-2 sm:gap-x-12">
              <li>
                <a href="#fonctionnement" className="text-ink-light-muted hover:text-ink-light">
                  Fonctionnement
                </a>
              </li>
              <li>
                <a href="#capacites" className="text-ink-light-muted hover:text-ink-light">
                  Ce qu’elle fait
                </a>
              </li>
              <li>
                <a href="#integrations" className="text-ink-light-muted hover:text-ink-light">
                  Intégrations
                </a>
              </li>
              <li>
                <a href="#securite" className="text-ink-light-muted hover:text-ink-light">
                  Sécurité
                </a>
              </li>
              <li>
                <a href="#tarifs" className="text-ink-light-muted hover:text-ink-light">
                  Tarifs
                </a>
              </li>
              <li>
                <a href={loginUrl} className="text-ink-light-muted hover:text-ink-light">
                  Connexion
                </a>
              </li>
              <li>
                <Link href="/app" className="text-ink-light-muted hover:text-ink-light">
                  Tableau de bord
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 border-t border-line-dark pt-6">
          <LegalFooter tone="dark" />
          <p className="mt-4 text-caption text-ink-light-muted">
            GSI Voice est une solution GSI Consulting.
          </p>
        </div>
      </div>
    </footer>
  );
}
